import {
  WEATHER_MAP_LAYOUT_ORIENTATIONS,
  WEATHER_MAP_RESIZABLE_LAYOUT_DEFAULTS,
} from '../config/weatherMapLayout.config';

const supportedOrientations = new Set(Object.values(WEATHER_MAP_LAYOUT_ORIENTATIONS));

export const resolveWeatherMapLayoutOrientation = (orientation, fallbackOrientation) =>
  supportedOrientations.has(orientation) ? orientation : fallbackOrientation;

export const getWeatherMapFlexDirectionClass = (orientation) =>
  orientation === WEATHER_MAP_LAYOUT_ORIENTATIONS.horizontal ? 'flex-row' : 'flex-column';

export const getWeatherMapPanelAxisClass = (orientation) =>
  orientation === WEATHER_MAP_LAYOUT_ORIENTATIONS.horizontal ? 'h-100' : 'w-100';

export const getWeatherMapResizeHandleDirection = (orientation) =>
  orientation === WEATHER_MAP_LAYOUT_ORIENTATIONS.horizontal
    ? WEATHER_MAP_LAYOUT_ORIENTATIONS.vertical
    : WEATHER_MAP_LAYOUT_ORIENTATIONS.horizontal;

export const getDefaultWeatherMapLayoutOrientation = (isResizable) =>
  isResizable
    ? WEATHER_MAP_RESIZABLE_LAYOUT_DEFAULTS.resizableOrientation
    : WEATHER_MAP_RESIZABLE_LAYOUT_DEFAULTS.nonResizableOrientation;
